import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { useRefereeDutiesListQuery } from '~/pages/referee-duties/queries';
import { Pagination } from '~/components/Pagination/Pagination';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';
import { formatDate } from '~/utils/date';
import { JudgeDuty } from '~/apis/ssf';

function Row({ results }: { results: JudgeDuty }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/competitions/${results.group.competition.id}/results`}>{results.group.competition.name}</Link>
      </Table.Col>
      <Table.Col>{results.group.name}</Table.Col>
      <Table.Col>{results.role.description}</Table.Col>
      <Table.Col>{formatDate(new Date(results.group.date), 'yyyy-mm-dd')}</Table.Col>
    </Table.Row>
  );
}

export function RefereeDutiesDetailListTable() {
  const { id } = useParams(idParamSchema.parse);
  const { values } = useFilterForm(paginationSchema.parse);
  const { data, isLoading } = useRefereeDutiesListQuery({
    judge: id,
    page_size: values.pageSize,
    page: values.pageIndex,
  });

  return (
    <Fragment>
      <PageLayout.SubHeading>Domaruppdrag</PageLayout.SubHeading>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Tävling</Table.Col>
            <Table.Col as="th">Grupp</Table.Col>
            <Table.Col as="th">Roll</Table.Col>
            <Table.Col as="th">Datum</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={4} />
          ) : (
            data?.results.map(results => <Row results={results} key={results.id} />)
          )}
        </Table.Body>
      </Table>
      <Pagination count={data?.count} />
    </Fragment>
  );
}
